<div class="icon-wrapper">
  <i class="icon">{{nameIcon}}</i>
</div>

